import React from "react";

import HealthArrow from "$components/health-arrow";
import LargeNumber from "$components/info-list/content/large-number";

import { abbrNum } from "$utils/number-helper";

const StatWithChange = ({ label, value = 0, increase, isHealthy, tooltip, preSup = "$" }) => {
    return (
        <div className="stat">
            <h4 data-tooltip={tooltip} dangerouslySetInnerHTML={{ __html: label }}></h4>
            <div className="stats">
                <LargeNumber value={`${preSup}${abbrNum(value)}`} isHealthy={isHealthy} />
                {increase ? <HealthArrow isHealthy={increase >= 0} isIncrease={increase >= 0} /> : null}
                {!isNaN(increase) && <div>{Math.abs(increase)}%</div>}
            </div>
        </div>
    );
};

export default StatWithChange;
